export class AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerProjection {
    'projectionType';
    'nonKeyAttributes';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "projectionType",
            "baseName": "projectionType",
            "type": "string",
            "format": ""
        },
        {
            "name": "nonKeyAttributes",
            "baseName": "nonKeyAttributes",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerProjection.attributeTypeMap;
    }
    constructor() {
    }
}
